<template>
    <VisSingleContainer :height="100">
        <VisDonut
            :value="(d) => d.value"
            :data="data"
            :color="(d) => (d.key === 'compliant' ? '#22c55e' : '#ef4444')"
            :central-label="`${data[0].value} %`"
            :show-empty-segments="true"
            :pad-angle="0.01"
            :arc-width="15"
        />
    </VisSingleContainer>

    <p class="mt-4 text-center font-medium text-black">DMARC Compliance</p>
</template>

<script setup lang="ts">
import { VisSingleContainer, VisDonut } from "@unovis/vue";
import { defineProps } from "vue";

interface DataRecord {
    key: string;
    value: number;
}

defineProps<{
    data: DataRecord[];
}>();
</script>
